const MIME_FALLBACK: Record<string, string> = {
	".heic": "image/heic",
	".heif": "image/heif",
	".avif": "image/avif",
	".webp": "image/webp",
	".tiff": "image/tiff",
	".tif": "image/tiff"
};

export function getFileExtension(fileName: string): string {
	const parts = fileName.split(".");
	if (parts.length <= 1) return "";
	return "." + parts.pop()!.toLowerCase();
}

export function getFileContentType(file: File): string {
	if (file.type) return file.type;
	return MIME_FALLBACK[getFileExtension(file.name)] ?? "application/octet-stream";
}

export function isImageFile(file: File): boolean {
	return getFileContentType(file).startsWith("image/");
}
